import { View } from "./View";

interface ICheckoutPaymentpage{
  rightcontent: string;
 leftcontent: string;
}

export const SubAndEmailPage  = (
  props: ICheckoutPaymentpage
) => {
  return <View {...props}  />;
};
